import { Button, Form, Input, Select } from "antd";
import { getFullName } from "modules/utilities/utility";
import { memo } from "react";
import { Modal } from "react-bootstrap";

const UserCallProviderModal = ({
  user,
  isModalOpen = false,
  handleToggleModal,
  handleSubmitForm,
  type,
  usersList,
  providersList,
}) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    handleSubmitForm(user?.user_call_provider_id, values);
  };
  const isNew = type === "new";
  const initialValues = isNew
    ? {
        externalAgentId: "",
        userId: undefined,
        nextCall: false,
        providerId: undefined,
      }
    : {
        externalAgentId: user?.external_agent_id,
      };
  const { data } = providersList;

  return (
    <Modal show={isModalOpen} onHide={() => handleToggleModal({})}>
      <Modal.Header closeButton>
        <Modal.Title>
          {isNew
            ? "Add New User Call Provider"
            : _.startCase(type) + " User Call Provider"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          form={form}
          layout="vertical"
          initialValues={initialValues}
          onFinish={onFinish}
        >
          {isNew && (
            <>
              <Form.Item
                name="userId"
                label="Select User"
                rules={[
                  {
                    required: true,
                    message: "Please select a user!",
                  },
                ]}
              >
                <Select
                  placeholder="Select a user"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {Array.isArray(usersList) &&
                    usersList.map(({ user }) => (
                      <Select.Option key={user.id} value={user.id}>
                        {getFullName(user)}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="nextCall"
                label="Next Call"
                rules={[
                  {
                    required: true,
                    message: "Please select if Next Call!",
                  },
                ]}
              >
                <Select placeholder="Select Yes or No">
                  <Select.Option value={true}>Yes</Select.Option>
                  <Select.Option value={false}>No</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="providerId"
                label="Select Provider"
                rules={[
                  {
                    required: true,
                    message: "Please select a provider!",
                  },
                ]}
              >
                <Select
                  placeholder="Select a provider"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {Array.isArray(data) &&
                    data.map((provider) => (
                      <Select.Option key={provider.id} value={provider.id}>
                        {provider.provider_name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </>
          )}
          <Form.Item
            name="externalAgentId"
            label="External Agent ID"
            rules={[
              {
                required: false,
                message: "Please input External Agent ID!",
              },
            ]}
          >
            <Input placeholder="Enter External Agent ID" />
          </Form.Item>
          <div className="d-flex gap-2 justify-content-end border-top pt-4">
            <Form.Item>
              <Button
                variant="secondary"
                onClick={() => handleToggleModal()} // Ensure the modal is closed properly
              >
                Close
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit" // Ensure this button triggers form submission
              >
                {isNew ? "Add New" : "Save Changes"}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default memo(UserCallProviderModal);
